export default {
  language: "es",
}
